import mock from '@/@fake-db/mock'
/* eslint-disable global-require */
const data = {
  mainList: [
    {
      id: 1,
      label: 'เรื่องร้องทุกข์',
      sublabel: '** สามารถตอบได้มากกว่า 1 รายการ',
      sublabel_color: 'danger',
      data: [
        { id: '1', name: 'อสังหาริมทรัพย์' },
        { id: '8', name: 'สินค้า' },
        { id: '9', name: 'บริการ' },
      ],
    },
  ],
  subList: [
    {
      id: 2,
      label: 'ประเภทร้องทุกข์',
      sublabel: '** สามารถตอบได้มากกว่า 1 รายการ',
      sublabel_color: 'danger',
      data: [
        { id: '2', name: 'บ้านจัดสรร (ทาวน์เฮ้าส์)', parent: '1' },
        { id: '3', name: 'บ้านจัดสรร (ทาวน์โฮม)', parent: '1' },
        { id: '4', name: 'บ้านจัดสรร (บ้านแฝด)', parent: '1' },
        { id: '5', name: 'บ้านจัดสรร (บ้านเดี่ยว)', parent: '1' },
        { id: '6', name: 'อาคารชุด/คอนโดมิเนียม', parent: '1' },
        { id: '88', name: 'อพาร์ทเมนต์/หอพัก/ห้องเช่า/บ้านเช่า', parent: '1' },
        { id: '109', name: 'อาคารพาณิชย์', parent: '1' },
        { id: '111', name: 'ที่ดิน', parent: '1' },
        { id: '125', name: 'เช่าพื้นที่/เช่าช่วง', parent: '1' },
        { id: '128', name: 'ว่าจ้างก่อสร้าง', parent: '1' },
        { id: '132', name: 'ที่ดินพร้อมสิ่งปลูกสร้าง', parent: '1' },
        { id: '32', name: 'วัตถุมงคล', parent: '8' },
        { id: '33', name: 'เครื่องสำอาง/เวชสำอาง', parent: '8' },
        { id: '34', name: 'อุปกรณ์ไฟฟ้า', parent: '8' },
        { id: '35', name: 'เฟอร์นิเจอร์', parent: '8' },
        { id: '36', name: 'เครื่องใช้สำนักงาน', parent: '8' },
        { id: '37', name: 'รถจักรยานยนต์', parent: '8' },
        { id: '38', name: 'เครื่องมือสื่อสาร', parent: '8' },
        { id: '39', name: 'หนังสือ/นิตยสาร', parent: '8' },
        { id: '41', name: 'เวชภัณฑ์ยา', parent: '8' },
        { id: '42', name: 'บัตรเติมเงิน', parent: '8' },
        { id: '43', name: 'รถยนต์ ', parent: '8' },
        { id: '44', name: 'รถยนต์มือสอง', parent: '8' },
        { id: '65', name: 'อุปกรณ์คอมพิวเตอร์', parent: '8' },
        { id: '67', name: 'เสื้อผ้าเครื่องนุ่งห่ม', parent: '8' },
        { id: '75', name: 'เครื่องใช้ไฟฟ้า', parent: '8' },
        { id: '78', name: 'วัสดุก่อสร้าง', parent: '8' },
        { id: '80', name: 'รถจักรยาน', parent: '8' },
        { id: '83', name: 'ธุรกิจขายตรง', parent: '8' },
        { id: '94', name: 'สินค้าและบริการ/ เครื่องมือด้านการเกษตร', parent: '8' },
        { id: '95', name: 'เครื่องประดับ', parent: '8' },
        { id: '96', name: 'สินค้าและบริการ (ไม่ระบุ)', parent: '8' },
        { id: '100', name: 'สินค้าบริโภค', parent: '8' },
        { id: '114', name: 'รถบรรทุก', parent: '8' },
        { id: '117', name: 'ธุรกิจตลาดแบบตรง', parent: '8' },
        { id: '134', name: 'ผลิตภัณฑ์เสริมอาหาร', parent: '8' },
        { id: '7', name: 'สุขภาพ', parent: '9' },
        { id: '12', name: 'ประปา', parent: '9' },
        { id: '18', name: 'คลินิก/ สถาบันเสริมความงาม/ร้านเสริมสวย', parent: '9' },
        { id: '19', name: 'โรงพิมพ์', parent: '9' },
        { id: '20', name: 'ประกันภัย', parent: '9' },
        { id: '21', name: 'ศูนย์บริการ', parent: '9' },
        { id: '22', name: 'ร้านซ่อมเครื่องใช้ไฟฟ้า', parent: '9' },
        { id: '23', name: 'ร้านซ่อมคอมพิวเตอร์', parent: '9' },
        { id: '24', name: 'ที่จอดรถ', parent: '9' },
        { id: '25', name: 'ร้านถ่ายเอกสาร', parent: '9' },
        { id: '26', name: 'สถานศึกษา', parent: '9' },
        { id: '27', name: 'ตรวจสอบค่าธรรมเนียม', parent: '9' },
        { id: '29', name: 'รถร่วมบริการ', parent: '9' },
        { id: '30', name: 'บัตรเครดิต', parent: '9' },
        { id: '31', name: 'เช่าซื้อ (รถยนต์/รถจักรยายนต์/รถยนต์มือสอง)', parent: '9' },
        { id: '40', name: 'ธุรกิจขายตรง', parent: '9' },
        { id: '45', name: 'วิทยาลัย', parent: '9' },
        { id: '46', name: 'ห้างสรรพสินค้า', parent: '9' },
        { id: '47', name: 'โทรศัพท์', parent: '9' },
        { id: '48', name: 'สนามกอล์ฟ', parent: '9' },
        { id: '49', name: 'บริการจัดหางาน', parent: '9' },
        { id: '50', name: 'ไปรษณีย์', parent: '9' },
        { id: '51', name: 'ร้านถ่ายรูป', parent: '9' },
        { id: '52', name: 'ปั๊มน้ำมัน / LPG / NGV', parent: '9' },
        { id: '53', name: 'ผู้ประกอบการทั่วไป', parent: '9' },
        { id: '54', name: 'ร้านขายสัตว์เลี้ยง', parent: '9' },
        { id: '55', name: 'โรงรับจำนำ', parent: '9' },
        { id: '56', name: 'เนอร์สเซอรี', parent: '9' },
        { id: '57', name: 'รถทัวร์', parent: '9' },
        { id: '58', name: 'รถตู้ร่วมบริการ', parent: '9' },
        { id: '59', name: 'บริษัทไฟแนนซ์', parent: '9' },
        { id: '60', name: 'สินเชื่อ (สถาบันการเงิน)', parent: '9' },
        { id: '61', name: 'สินเชื่อ (ธนาคาร)', parent: '9' },
        { id: '62', name: 'ธุรกิจตลาดแบบตรง', parent: '9' },
        { id: '64', name: 'มหาวิทยาลัย', parent: '9' },
        { id: '66', name: 'โรงพยาบาล/ คลินิก', parent: '9' },
        { id: '68', name: 'Internet', parent: '9' },
        { id: '69', name: 'ฟิตเนส', parent: '9' },
        { id: '71', name: 'อู่ซ่อมรถ', parent: '9' },
        { id: '72', name: 'ร้านอาหาร', parent: '9' },
        { id: '73', name: 'เนอร์สซิ่งโฮม', parent: '9' },
        { id: '74', name: 'ร้านจำหน่าย/ ติดตั้งเครื่องใช้ไฟฟ้า', parent: '9' },
        { id: '76', name: 'ร้านสตูดิโอ', parent: '9' },
        { id: '77', name: 'ร้านซ่อมเครื่องประดับ', parent: '9' },
        { id: '79', name: 'บริการขนส่ง (รับจ้างขนส่ง)', parent: '9' },
        { id: '81', name: 'มลภาวะทางเสียง', parent: '9' },
        { id: '82', name: 'รถ บขส.', parent: '9' },
        { id: '85', name: 'เรือโดยสาร', parent: '9' },
        { id: '86', name: 'ตราสารหนี้', parent: '9' },
        { id: '87', name: 'มลภาวะทางอากาศ', parent: '9' },
        { id: '89', name: 'การศึกษานอกโรงเรียน', parent: '9' },
        { id: '90', name: 'ไฟฟ้า', parent: '9' },
        { id: '91', name: 'ร้านสะดวกซื้อ', parent: '9' },
        { id: '92', name: 'สปา', parent: '9' },
        { id: '93', name: 'ประกันชีวิต', parent: '9' },
        { id: '99', name: 'รถเช่า', parent: '9' },
        { id: '101', name: 'Internet Café', parent: '9' },
        { id: '102', name: 'กำจัดปลวก', parent: '9' },
        { id: '103', name: 'ศูนย์ซ่อมอุปกรณ์ไฟฟ้า', parent: '9' },
        { id: '105', name: 'ร้านขายแก๊สหุงต้ม', parent: '9' },
        { id: '106', name: 'โรงแรม (ท่องเที่ยว)', parent: '9' },
        { id: '107', name: 'รีสอร์ท (ท่องเที่ยว)', parent: '9' },
        { id: '108', name: 'ผู้ประกอบการด้านการท่องเที่ยว (ท่องเที่ยว)', parent: '9' },
        { id: '112', name: 'ธุรกิจไทม์แชร์(Timeshare) / ธุรกิจจัดสรรวันพักผ่อน (ท่องเที่ยว)', parent: '9' },
        { id: '113', name: 'จองตั๋วเครื่องบิน/สายการบิน', parent: '9' },
        { id: '118', name: 'ตัวแทนจำหน่าย (สายการบิน)', parent: '9' },
        { id: '119', name: 'รถรับจ้างสาธารณะ (Taxi)', parent: '9' },
        { id: '120', name: 'รถ ขสมก.', parent: '9' },
        { id: '121', name: 'หุ้น', parent: '9' },
        { id: '122', name: 'มลภาวะทางน้ำ', parent: '9' },
        { id: '129', name: 'สถาบัน', parent: '9' },
        { id: '131', name: 'สัญญาบริการ', parent: '9' },
        { id: '133', name: 'สินเชื่อรถยนต์', parent: '9' },
      ],
    },
  ],
  causeList: [
    {
      id: 3,
      label: 'สาเหตุเรื่องร้องทุกข์',
      sublabel: '** สามารถตอบได้มากกว่า 1 รายการ',
      sublabel_color: 'danger',
      data: [
        {
          row: '1', id: '152', name: 'ขอแก้ไขเพิ่มเติมสัญญา', parent: '2',
        },
        {
          row: '2', id: '159', name: 'ขอคำปรึกษา', parent: '2',
        },
        {
          row: '3', id: '167', name: 'ก่อสร้างไม่แล้วเสร็จ', parent: '2',
        },
        {
          row: '4', id: '21', name: 'มีการก่อสร้างแล้วเสร็จแต่เก็บงานไม่เรียบร้อย', parent: '2',
        },
        {
          row: '5', id: '12', name: 'ไม่ปลูกสร้าง', parent: '2',
        },
        {
          row: '6', id: '14', name: 'ไม่ดำเนินการตามที่โฆษณา', parent: '2',
        },
        {
          row: '7', id: '15', name: 'ไม่ดำเนินการโอนกรรมสิทธิ์', parent: '2',
        },
        {
          row: '8', id: '16', name: 'ไม่ดำเนินการแบ่งแยกโฉนด', parent: '2',
        },
        {
          row: '9', id: '17', name: 'มีการชำรุดหลังปลูกสร้าง', parent: '2',
        },
        {
          row: '10', id: '223', name: 'สถาบันการเงินอนุมัติสินเชื่อ ไม่เต็มจำนวนเงิน', parent: '2',
        },
        {
          row: '11', id: '225', name: 'ก่อสร้างไม่เหมือนบ้านตัวอย่าง', parent: '2',
        },
        {
          row: '12', id: '226', name: 'แบบสัญญาไม่เป็นไปตามที่กฎหมายกำหนด', parent: '2',
        },
        {
          row: '13', id: '19', name: 'ไม่จัดทำสาธารณูปโภคในโครงการ', parent: '2',
        },
        {
          row: '14', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '2',
        },
        {
          row: '15', id: '227', name: 'การบริหารงานของนิติบุคคลหมู่บ้านจัดสรรไม่โปร่งใส', parent: '2',
        },
        {
          row: '16', id: '229', name: 'ไม่ดูแลและพัฒนาสาธารณูปโภคในโครงการ ', parent: '2',
        },
        {
          row: '17', id: '230', name: 'ปิดทางเข้าออกโครงการ', parent: '2',
        },
        {
          row: '18', id: '231', name: 'ผู้ประกอบการไม่ชำระค่าปรับล่าช้า', parent: '2',
        },
        {
          row: '19', id: '234', name: 'สถาบันการเงินไม่อนุมัติสินเชื่อ', parent: '2',
        },
        {
          row: '20', id: '237', name: 'ก่อสร้างไม่ถูกต้องตามแปลนที่ได้รับอนุญาตตามราชการ', parent: '2',
        },
        {
          row: '21', id: '236', name: 'จำนวนเนื้อที่ไม่ตรงกับที่โฆษณา/ใบจอง/สัญญา', parent: '2',
        },
        {
          row: '22', id: '144', name: 'ขอให้ตรวจสอบโครงการ', parent: '2',
        },
        {
          row: '23', id: '236', name: 'จำนวนเนื้อที่ไม่ตรงกับที่โฆษณา/ใบจอง/สัญญา', parent: '3',
        },
        {
          row: '24', id: '237', name: 'ก่อสร้างไม่ถูกต้องตามแปลนที่ได้รับอนุญาตตามราชการ', parent: '3',
        },
        {
          row: '25', id: '144', name: 'ขอให้ตรวจสอบโครงการ', parent: '3',
        },
        {
          row: '26', id: '232', name: 'ขอให้แก้ไขเพิ่มเติมสัญญา', parent: '3',
        },
        {
          row: '27', id: '159', name: 'ขอคำปรึกษา', parent: '3',
        },
        {
          row: '28', id: '167', name: 'ก่อสร้างไม่แล้วเสร็จ', parent: '3',
        },
        {
          row: '29', id: '21', name: 'มีการก่อสร้างแล้วเสร็จแต่เก็บงานไม่เรียบร้อย', parent: '3',
        },
        {
          row: '30', id: '12', name: 'ไม่ปลูกสร้าง', parent: '3',
        },
        {
          row: '31', id: '14', name: 'ไม่ดำเนินการตามที่โฆษณา', parent: '3',
        },
        {
          row: '32', id: '15', name: 'ไม่ดำเนินการโอนกรรมสิทธิ์', parent: '3',
        },
        {
          row: '33', id: '16', name: 'ไม่ดำเนินการแบ่งแยกโฉนด', parent: '3',
        },
        {
          row: '34', id: '17', name: 'มีการชำรุดหลังปลูกสร้าง', parent: '3',
        },
        {
          row: '35', id: '223', name: 'สถาบันการเงินอนุมัติสินเชื่อ ไม่เต็มจำนวนเงิน', parent: '3',
        },
        {
          row: '36', id: '225', name: 'ก่อสร้างไม่เหมือนบ้านตัวอย่าง', parent: '3',
        },
        {
          row: '37', id: '226', name: 'แบบสัญญาไม่เป็นไปตามที่กฎหมายกำหนด', parent: '3',
        },
        {
          row: '38', id: '227', name: 'การบริหารงานของนิติบุคคลหมู่บ้านจัดสรรไม่โปร่งใส', parent: '3',
        },
        {
          row: '39', id: '19', name: 'ไม่จัดทำสาธารณูปโภคในโครงการ', parent: '3',
        },
        {
          row: '40', id: '229', name: 'ไม่ดูแลและพัฒนาสาธารณูปโภคในโครงการ ', parent: '3',
        },
        {
          row: '41', id: '230', name: 'ปิดทางเข้าออกโครงการ', parent: '3',
        },
        {
          row: '42', id: '231', name: 'ผู้ประกอบการไม่ชำระค่าปรับล่าช้า', parent: '3',
        },
        {
          row: '43', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '3',
        },
        {
          row: '44', id: '234', name: 'สถาบันการเงินไม่อนุมัติสินเชื่อ', parent: '3',
        },
        {
          row: '45', id: '237', name: 'ก่อสร้างไม่ถูกต้องตามแปลนที่ได้รับอนุญาตตามราชการ', parent: '4',
        },
        {
          row: '46', id: '227', name: 'การบริหารงานของนิติบุคคลหมู่บ้านจัดสรรไม่โปร่งใส', parent: '4',
        },
        {
          row: '47', id: '231', name: 'ผู้ประกอบการไม่ชำระค่าปรับล่าช้า', parent: '4',
        },
        {
          row: '48', id: '226', name: 'แบบสัญญาไม่เป็นไปตามที่กฎหมายกำหนด', parent: '4',
        },
        {
          row: '49', id: '144', name: 'ขอให้ตรวจสอบโครงการ', parent: '4',
        },
        {
          row: '50', id: '232', name: 'ขอให้แก้ไขเพิ่มเติมสัญญา', parent: '4',
        },
        {
          row: '51', id: '159', name: 'ขอคำปรึกษา', parent: '4',
        },
        {
          row: '52', id: '167', name: 'ก่อสร้างไม่แล้วเสร็จ', parent: '4',
        },
        {
          row: '53', id: '225', name: 'ก่อสร้างไม่เหมือนบ้านตัวอย่าง', parent: '4',
        },
        {
          row: '54', id: '21', name: 'มีการก่อสร้างแล้วเสร็จแต่เก็บงานไม่เรียบร้อย', parent: '4',
        },
        {
          row: '55', id: '12', name: 'ไม่ปลูกสร้าง', parent: '4',
        },
        {
          row: '56', id: '14', name: 'ไม่ดำเนินการตามที่โฆษณา', parent: '4',
        },
        {
          row: '57', id: '15', name: 'ไม่ดำเนินการโอนกรรมสิทธิ์', parent: '4',
        },
        {
          row: '58', id: '16', name: 'ไม่ดำเนินการแบ่งแยกโฉนด', parent: '4',
        },
        {
          row: '59', id: '17', name: 'มีการชำรุดหลังปลูกสร้าง', parent: '4',
        },
        {
          row: '60', id: '223', name: 'สถาบันการเงินอนุมัติสินเชื่อ ไม่เต็มจำนวนเงิน', parent: '4',
        },
        {
          row: '61', id: '234', name: 'สถาบันการเงินไม่อนุมัติสินเชื่อ', parent: '4',
        },
        {
          row: '62', id: '236', name: 'จำนวนเนื้อที่ไม่ตรงกับที่โฆษณา/ใบจอง/สัญญา', parent: '4',
        },
        {
          row: '63', id: '19', name: 'ไม่จัดทำสาธารณูปโภคในโครงการ', parent: '4',
        },
        {
          row: '64', id: '229', name: 'ไม่ดูแลและพัฒนาสาธารณูปโภคในโครงการ ', parent: '4',
        },
        {
          row: '65', id: '230', name: 'ปิดทางเข้าออกโครงการ', parent: '4',
        },
        {
          row: '66', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '4',
        },
        {
          row: '67', id: '144', name: 'ขอให้ตรวจสอบโครงการ', parent: '5',
        },
        {
          row: '68', id: '232', name: 'ขอให้แก้ไขเพิ่มเติมสัญญา', parent: '5',
        },
        {
          row: '69', id: '159', name: 'ขอคำปรึกษา', parent: '5',
        },
        {
          row: '70', id: '167', name: 'ก่อสร้างไม่แล้วเสร็จ', parent: '5',
        },
        {
          row: '71', id: '21', name: 'มีการก่อสร้างแล้วเสร็จแต่เก็บงานไม่เรียบร้อย', parent: '5',
        },
        {
          row: '72', id: '12', name: 'ไม่ปลูกสร้าง', parent: '5',
        },
        {
          row: '73', id: '14', name: 'ไม่ดำเนินการตามที่โฆษณา', parent: '5',
        },
        {
          row: '74', id: '15', name: 'ไม่ดำเนินการโอนกรรมสิทธิ์', parent: '5',
        },
        {
          row: '75', id: '16', name: 'ไม่ดำเนินการแบ่งแยกโฉนด', parent: '5',
        },
        {
          row: '76', id: '17', name: 'มีการชำรุดหลังปลูกสร้าง', parent: '5',
        },
        {
          row: '77', id: '234', name: 'สถาบันการเงินไม่อนุมัติสินเชื่อ', parent: '5',
        },
        {
          row: '78', id: '223', name: 'สถาบันการเงินอนุมัติสินเชื่อ ไม่เต็มจำนวนเงิน', parent: '5',
        },
        {
          row: '79', id: '236', name: 'จำนวนเนื้อที่ไม่ตรงกับที่โฆษณา/ใบจอง/สัญญา', parent: '5',
        },
        {
          row: '80', id: '237', name: 'ก่อสร้างไม่ถูกต้องตามแปลนที่ได้รับอนุญาตตามราชการ', parent: '5',
        },
        {
          row: '81', id: '225', name: 'ก่อสร้างไม่เหมือนบ้านตัวอย่าง', parent: '5',
        },
        {
          row: '82', id: '226', name: 'แบบสัญญาไม่เป็นไปตามที่กฎหมายกำหนด', parent: '5',
        },
        {
          row: '83', id: '227', name: 'การบริหารงานของนิติบุคคลหมู่บ้านจัดสรรไม่โปร่งใส', parent: '5',
        },
        {
          row: '84', id: '19', name: 'ไม่จัดทำสาธารณูปโภคในโครงการ', parent: '5',
        },
        {
          row: '85', id: '229', name: 'ไม่ดูแลและพัฒนาสาธารณูปโภคในโครงการ ', parent: '5',
        },
        {
          row: '86', id: '230', name: 'ปิดทางเข้าออกโครงการ', parent: '5',
        },
        {
          row: '87', id: '231', name: 'ผู้ประกอบการไม่ชำระค่าปรับล่าช้า', parent: '5',
        },
        {
          row: '88', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '5',
        },
        {
          row: '89', id: '91', name: 'ยกเลิกสัญญาและขอเงินคืน', parent: '6',
        },
        {
          row: '90', id: '261', name: 'ขอเงินคืน', parent: '6',
        },
        {
          row: '91', id: '112', name: 'ขอเงินค่ามัดจำคืน', parent: '6',
        },
        {
          row: '92', id: '232', name: 'ขอให้แก้ไขเพิ่มเติมสัญญา', parent: '6',
        },
        {
          row: '93', id: '159', name: 'ขอคำปรึกษา', parent: '6',
        },
        {
          row: '94', id: '167', name: 'ก่อสร้างไม่แล้วเสร็จ', parent: '6',
        },
        {
          row: '95', id: '21', name: 'มีการก่อสร้างแล้วเสร็จแต่เก็บงานไม่เรียบร้อย', parent: '6',
        },
        {
          row: '96', id: '12', name: 'ไม่ปลูกสร้าง', parent: '6',
        },
        {
          row: '97', id: '14', name: 'ไม่ดำเนินการตามที่โฆษณา', parent: '6',
        },
        {
          row: '98', id: '251', name: 'ไม่ดำเนินการแบ่งแยกโฉนดที่ดิน', parent: '6',
        },
        {
          row: '99', id: '250', name: 'ไม่ดำเนินการโอนตามกรรมสิทธิ์', parent: '6',
        },
        {
          row: '100', id: '233', name: 'ไม่ดำเนินการจดทะเบียนการโอนกรรมสิทธิ์ห้องชุด', parent: '6',
        },
        {
          row: '101', id: '235', name: 'มีการชำรุดหลังปลูกสร้างของอาคาร/รอยร้าว/ผนัง/อาคารแตกแยก', parent: '6',
        },
        {
          row: '102', id: '234', name: 'สถาบันการเงินไม่อนุมัติสินเชื่อ', parent: '6',
        },
        {
          row: '103', id: '223', name: 'สถาบันการเงินอนุมัติสินเชื่อ ไม่เต็มจำนวนเงิน', parent: '6',
        },
        {
          row: '104', id: '236', name: 'จำนวนเนื้อที่ไม่ตรงกับที่โฆษณา/ใบจอง/สัญญา', parent: '6',
        },
        {
          row: '105', id: '237', name: 'ก่อสร้างไม่ถูกต้องตามแปลนที่ได้รับอนุญาตตามราชการ', parent: '6',
        },
        {
          row: '106', id: '238', name: 'ก่อสร้างไม่เหมือนห้องตัวอย่าง', parent: '6',
        },
        {
          row: '107', id: '226', name: 'แบบสัญญาไม่เป็นไปตามที่กฎหมายกำหนด', parent: '6',
        },
        {
          row: '108', id: '239', name: 'การบริหารงานของนิติบุคคลอาคารชุดไม่โปร่งใส', parent: '6',
        },
        {
          row: '109', id: '19', name: 'ไม่จัดทำสาธารณูปโภคในโครงการ', parent: '6',
        },
        {
          row: '110', id: '229', name: 'ไม่ดูแลและพัฒนาสาธารณูปโภคในโครงการ ', parent: '6',
        },
        {
          row: '111', id: '230', name: 'ปิดทางเข้าออกโครงการ', parent: '6',
        },
        {
          row: '112', id: '231', name: 'ผู้ประกอบการไม่ชำระค่าปรับล่าช้า', parent: '6',
        },
        {
          row: '113', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '6',
        },
        {
          row: '114', id: '79', name: 'ยกเลิกสัญญา', parent: '7',
        },
        {
          row: '115', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '7',
        },
        {
          row: '116', id: '122', name: 'ตรวจสอบข้อเท็จจริง', parent: '12',
        },
        {
          row: '117', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '12',
        },
        {
          row: '118', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '13',
        },
        {
          row: '119', id: '45', name: 'ตรวจสอบการให้บริการ', parent: '13',
        },
        {
          row: '120', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '13',
        },
        {
          row: '121', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '14',
        },
        {
          row: '122', id: '45', name: 'ตรวจสอบการให้บริการ', parent: '14',
        },
        {
          row: '123', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '14',
        },
        {
          row: '124', id: '68', name: 'กระเป๋าเดินทางสูญหาย/ชำรุดเสียหาย', parent: '15',
        },
        {
          row: '125', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '15',
        },
        {
          row: '126', id: '86', name: 'ขอคืนค่าโดยสาร', parent: '15',
        },
        {
          row: '127', id: '45', name: 'ตรวจสอบการให้บริการ', parent: '15',
        },
        {
          row: '128', id: '69', name: 'คิดค่าตั๋วไม่เป็นธรรม', parent: '15',
        },
        {
          row: '129', id: '67', name: 'เที่ยวบินล่าช้า', parent: '15',
        },
        {
          row: '130', id: '61', name: 'ไม่คืนเงินค่าโดยสารตามกำหนด', parent: '15',
        },
        {
          row: '131', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '15',
        },
        {
          row: '132', id: '66', name: 'ยกเลิกเที่ยวบิน', parent: '15',
        },
        {
          row: '133', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '16',
        },
        {
          row: '134', id: '86', name: 'ขอคืนค่าโดยสาร', parent: '16',
        },
        {
          row: '135', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '16',
        },
        {
          row: '136', id: '96', name: 'ไม่ดำเนินการตามสัญญา', parent: '16',
        },
        {
          row: '137', id: '99', name: 'ไม่ได้รับความเป็นธรรม', parent: '16',
        },
        {
          row: '138', id: '91', name: 'ยกเลิกสัญญาและขอเงินคืน', parent: '16',
        },
        {
          row: '139', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '17',
        },
        {
          row: '140', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '17',
        },
        {
          row: '141', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '18',
        },
        {
          row: '142', id: '209', name: 'ได้รับผลกระทบ/บาดเจ็บจากการเสริมความงาม', parent: '18',
        },
        {
          row: '143', id: '210', name: ' คลินิก/ร้าน ปิดกิจการ', parent: '18',
        },
        {
          row: '144', id: '211', name: 'คุณภาพบริการ', parent: '18',
        },
        {
          row: '145', id: '212', name: 'ไม่สามารถยกเลิกสัญญาได้', parent: '18',
        },
        {
          row: '146', id: '195', name: 'เรียกร้องค่าเสียหาย', parent: '18',
        },
        {
          row: '147', id: '262', name: 'ขอเงินคืน/ยังไม่ได้ใช้บริการ', parent: '18',
        },
        {
          row: '148', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '19',
        },
        {
          row: '149', id: '139', name: 'ไม่ยอมให้ยกเลิกกรมธรรม์', parent: '20',
        },
        {
          row: '150', id: '92', name: 'ปฏิเสธการจ่ายค่าสินไหม', parent: '20',
        },
        {
          row: '151', id: '45', name: 'ตรวจสอบการให้บริการ', parent: '20',
        },
        {
          row: '152', id: '84', name: 'ซ่อมล่าช้า', parent: '21',
        },
        {
          row: '153', id: '186', name: 'ตรวจสอบพฤติกรรมของพนักงาน', parent: '21',
        },
        {
          row: '154', id: '45', name: 'ตรวจสอบการให้บริการ', parent: '21',
        },
        {
          row: '155', id: '124', name: 'บริการหลังการขายไม่เป็นตามสัญญา', parent: '22',
        },
        {
          row: '156', id: '20', name: 'ไม่เป็นไปตามที่ระบุไว้ในสัญญา', parent: '22',
        },
        {
          row: '157', id: '84', name: 'ซ่อมล่าช้า', parent: '23',
        },
        {
          row: '158', id: '97', name: 'ราคาไม่เหมาะสม', parent: '24',
        },
        {
          row: '159', id: '159', name: 'ขอคำปรึกษา', parent: '24',
        },
        {
          row: '160', id: '147', name: 'ถ่ายเอกสารไม่ได้คุณภาพ', parent: '25',
        },
        {
          row: '161', id: '261', name: 'ขอเงินคืน', parent: '26',
        },
        {
          row: '162', id: '195', name: 'เรียกร้องค่าเสียหาย', parent: '26',
        },
        {
          row: '163', id: '200', name: 'ตรวจสอบพฤติกรรมครู', parent: '26',
        },
        {
          row: '164', id: '201', name: 'ไม่ดำเนินการตามข้อตกลง', parent: '26',
        },
        {
          row: '165', id: '37', name: 'ตรวจสอบค่าธรรมเนียม', parent: '26',
        },
        {
          row: '166', id: '65', name: 'ตรวจสอบค่าโดยสาร/ค่าเช่า', parent: '27',
        },
        {
          row: '167', id: '77', name: 'ขอเงินจองคืนกรณีไม่ได้รถ', parent: '27',
        },
        {
          row: '168', id: '112', name: 'ขอเงินค่ามัดจำคืน', parent: '27',
        },
        {
          row: '169', id: '151', name: 'ค้างค่างวด', parent: '27',
        },
        {
          row: '170', id: '161', name: 'ขอเงินจองคืน', parent: '27',
        },
        {
          row: '171', id: '45', name: 'ตรวจสอบการให้บริการ', parent: '27',
        },
        {
          row: '172', id: '65', name: 'ตรวจสอบค่าโดยสาร/ค่าเช่า', parent: '29',
        },
        {
          row: '173', id: '186', name: 'ตรวจสอบพฤติกรรมของพนักงาน', parent: '29',
        },
        {
          row: '174', id: '75', name: 'ค่าปรับสูง/ดอกเบี้ยล่าช้าสูง', parent: '30',
        },
        {
          row: '175', id: '76', name: 'ขอประนอมหนี้/ไม่มีเงินจ่าย', parent: '30',
        },
        {
          row: '176', id: '79', name: 'ยกเลิกสัญญา', parent: '30',
        },
        {
          row: '177', id: '95', name: 'ตรวจสอบการทำงานของเจ้าหน้าที่', parent: '30',
        },
        {
          row: '178', id: '118', name: 'ปิดบัญชีสินค้า', parent: '30',
        },
        {
          row: '179', id: '122', name: 'ตรวจสอบข้อเท็จจริง', parent: '30',
        },
        {
          row: '180', id: '133', name: 'ไม่ได้รับสินค้าจากการสะสมแต้ม', parent: '30',
        },
        {
          row: '181', id: '134', name: 'บัตรสูญหาย', parent: '30',
        },
        {
          row: '182', id: '148', name: 'สอบถามข้อมูล', parent: '30',
        },
        {
          row: '183', id: '157', name: 'พฤติกรรมการทวงหนี้', parent: '30',
        },
        {
          row: '184', id: '158', name: 'ขอเงินคืน', parent: '30',
        },
        {
          row: '185', id: '181', name: 'ไม่ได้ใช้บัตร', parent: '30',
        },
        {
          row: '186', id: '187', name: 'หักเงินจากบัญชี', parent: '30',
        },
        {
          row: '187', id: '80', name: 'คะแนนสะสมแต้ม', parent: '30',
        },
        {
          row: '188', id: '37', name: 'ตรวจสอบค่าธรรมเนียม', parent: '30',
        },
        {
          row: '189', id: '40', name: 'อัตราดอกเบี้ยสูงเกินไป', parent: '30',
        },
        {
          row: '190', id: '47', name: 'ขอให้ลดอัตราดอกเบี้ย', parent: '30',
        },
        {
          row: '191', id: '118', name: 'ปิดบัญชีสินค้า', parent: '31',
        },
        {
          row: '192', id: '122', name: 'ตรวจสอบข้อเท็จจริง', parent: '31',
        },
        {
          row: '193', id: '180', name: 'ค่าปรับสูงเกินจริง', parent: '31',
        },
        {
          row: '194', id: '81', name: 'ตรวจสอบค่าชำระงวด', parent: '31',
        },
        {
          row: '195', id: '37', name: 'ตรวจสอบค่าธรรมเนียม', parent: '31',
        },
        {
          row: '196', id: '40', name: 'อัตราดอกเบี้ยสูงเกินไป', parent: '31',
        },
        {
          row: '197', id: '47', name: 'ขอให้ลดอัตราดอกเบี้ย', parent: '31',
        },
        {
          row: '198', id: '39', name: 'ผิดสัญญาเช่าซื้อ', parent: '32',
        },
        {
          row: '199', id: '64', name: 'สินค้าชำรุด', parent: '32',
        },
        {
          row: '200', id: '105', name: 'สั่งซื้อสินค้าแล้วไม่ได้รับสินค้า', parent: '32',
        },
        {
          row: '201', id: '149', name: 'ขอคืนเงินจอง', parent: '32',
        },
        {
          row: '202', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '32',
        },
        {
          row: '203', id: '5', name: 'การโฆษณาอาจก่อให้เกิดความเข้าใจผิด', parent: '32',
        },
        {
          row: '204', id: '258', name: 'ผิดไปจากฉลากที่ระบุ', parent: '32',
        },
        {
          row: '205', id: '64', name: 'สินค้าชำรุด', parent: '33',
        },
        {
          row: '206', id: '105', name: 'สั่งซื้อสินค้าแล้วไม่ได้รับสินค้า', parent: '33',
        },
        {
          row: '207', id: '258', name: 'ผิดไปจากฉลากที่ระบุ', parent: '33',
        },
        {
          row: '208', id: '5', name: 'การโฆษณาอาจก่อให้เกิดความเข้าใจผิด', parent: '33',
        },
        {
          row: '209', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '33',
        },
        {
          row: '210', id: '64', name: 'สินค้าชำรุด', parent: '34',
        },
        {
          row: '211', id: '74', name: 'ชำรุด', parent: '34',
        },
        {
          row: '212', id: '87', name: 'ไม่ได้มาตรฐาน', parent: '34',
        },
        {
          row: '213', id: '105', name: 'สั่งซื้อสินค้าแล้วไม่ได้รับสินค้า', parent: '34',
        },
        {
          row: '214', id: '64', name: 'สินค้าชำรุด', parent: '35',
        },
        {
          row: '215', id: '87', name: 'ไม่ได้มาตรฐาน', parent: '35',
        },
        {
          row: '216', id: '105', name: 'สั่งซื้อสินค้าแล้วไม่ได้รับสินค้า', parent: '35',
        },
        {
          row: '217', id: '125', name: 'ไม่ประกันสินค้า', parent: '35',
        },
        {
          row: '218', id: '127', name: 'โฆษณาเกินจริง', parent: '35',
        },
        {
          row: '219', id: '64', name: 'สินค้าชำรุด', parent: '36',
        },
        {
          row: '220', id: '84', name: 'ซ่อมล่าช้า', parent: '36',
        },
        {
          row: '221', id: '87', name: 'ไม่ได้มาตรฐาน', parent: '36',
        },
        {
          row: '222', id: '96', name: 'ไม่ดำเนินการตามสัญญา', parent: '36',
        },
        {
          row: '223', id: '108', name: 'ไม่มีสินค้าตามโปรโมชั่น', parent: '36',
        },
        {
          row: '224', id: '125', name: 'ไม่ประกันสินค้า', parent: '36',
        },
        {
          row: '225', id: '127', name: 'โฆษณาเกินจริง', parent: '36',
        },
        {
          row: '226', id: '1', name: 'ผิดไปจากฉลากที่ระบุ', parent: '36',
        },
        {
          row: '227', id: '65', name: 'ตรวจสอบค่าโดยสาร/ค่าเช่า', parent: '37',
        },
        {
          row: '228', id: '71', name: 'ค้างค่างวด/คืนรถ/ส่วนต่างสูง', parent: '37',
        },
        {
          row: '229', id: '74', name: 'ชำรุด', parent: '37',
        },
        {
          row: '230', id: '75', name: 'ค่าปรับสูง/ดอกเบี้ยล่าช้าสูง', parent: '37',
        },
        {
          row: '231', id: '95', name: 'ตรวจสอบการทำงานของเจ้าหน้าที่', parent: '37',
        },
        {
          row: '232', id: '107', name: 'ตรวจสอบการซื้อขายรถจักรยานยนต์', parent: '37',
        },
        {
          row: '233', id: '122', name: 'ตรวจสอบข้อเท็จจริง', parent: '37',
        },
        {
          row: '234', id: '162', name: 'รถสูญหาย', parent: '37',
        },
        {
          row: '235', id: '188', name: 'ยึดรถคืน', parent: '37',
        },
        {
          row: '236', id: '81', name: 'ตรวจสอบค่าชำระงวด', parent: '37',
        },
        {
          row: '237', id: '174', name: 'ไม่ได้รับเล่มทะเบียน', parent: '37',
        },
        {
          row: '238', id: '15', name: 'ไม่ดำเนินการโอนกรรมสิทธิ์', parent: '37',
        },
        {
          row: '239', id: '37', name: 'ตรวจสอบค่าธรรมเนียม', parent: '37',
        },
        {
          row: '240', id: '1', name: 'ผิดไปจากฉลากที่ระบุ', parent: '37',
        },
        {
          row: '241', id: '64', name: 'สินค้าชำรุด', parent: '38',
        },
        {
          row: '242', id: '105', name: 'สั่งซื้อสินค้าแล้วไม่ได้รับสินค้า', parent: '38',
        },
        {
          row: '243', id: '122', name: 'ตรวจสอบข้อเท็จจริง', parent: '38',
        },
        {
          row: '244', id: '131', name: 'หักเงินโดยไม่แจ้ง', parent: '38',
        },
        {
          row: '245', id: '258', name: 'ผิดไปจากฉลากที่ระบุ', parent: '38',
        },
        {
          row: '246', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '38',
        },
        {
          row: '247', id: '5', name: 'การโฆษณาอาจก่อให้เกิดความเข้าใจผิด', parent: '38',
        },
        {
          row: '248', id: '1', name: 'ผิดไปจากฉลากที่ระบุ', parent: '38',
        },
        {
          row: '249', id: '1', name: 'ผิดไปจากฉลากที่ระบุ', parent: '39',
        },
        {
          row: '250', id: '64', name: 'สินค้าชำรุด', parent: '39',
        },
        {
          row: '251', id: '105', name: 'สั่งซื้อสินค้าแล้วไม่ได้รับสินค้า', parent: '39',
        },
        {
          row: '252', id: '130', name: 'ราคาขายสูงกว่าที่ระบุในฉลาก', parent: '39',
        },
        {
          row: '253', id: '258', name: 'ผิดไปจากฉลากที่ระบุ', parent: '39',
        },
        {
          row: '254', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '39',
        },
        {
          row: '255', id: '5', name: 'การโฆษณาอาจก่อให้เกิดความเข้าใจผิด', parent: '39',
        },
        {
          row: '256', id: '1', name: 'ผิดไปจากฉลากที่ระบุ', parent: '40',
        },
        {
          row: '257', id: '209', name: 'ได้รับผลกระทบ/บาดเจ็บจากการเสริมความงาม', parent: '40',
        },
        {
          row: '258', id: '210', name: ' คลินิก/ร้าน ปิดกิจการ', parent: '40',
        },
        {
          row: '259', id: '1', name: 'ผิดไปจากฉลากที่ระบุ', parent: '41',
        },
        {
          row: '260', id: '105', name: 'สั่งซื้อสินค้าแล้วไม่ได้รับสินค้า', parent: '41',
        },
        {
          row: '261', id: '89', name: 'ไม่มีใบอนุญาตในการจำหน่ายยา', parent: '41',
        },
        {
          row: '262', id: '90', name: 'ยาหมดอายุ', parent: '41',
        },
        {
          row: '263', id: '258', name: 'ผิดไปจากฉลากที่ระบุ', parent: '41',
        },
        {
          row: '264', id: '113', name: 'บัตรหมดอายุ', parent: '42',
        },
        {
          row: '265', id: '130', name: 'ราคาขายสูงกว่าที่ระบุในฉลาก', parent: '42',
        },
        {
          row: '266', id: '1', name: 'ผิดไปจากฉลากที่ระบุ', parent: '42',
        },
        {
          row: '267', id: '65', name: 'ตรวจสอบค่าโดยสาร/ค่าเช่า', parent: '43',
        },
        {
          row: '268', id: '70', name: 'ค่าปรับสูง', parent: '43',
        },
        {
          row: '269', id: '71', name: 'ค้างค่างวด/คืนรถ/ส่วนต่างสูง', parent: '43',
        },
        {
          row: '270', id: '74', name: 'ชำรุด', parent: '43',
        },
        {
          row: '271', id: '76', name: 'ขอประนอมหนี้/ไม่มีเงินจ่าย', parent: '43',
        },
        {
          row: '272', id: '77', name: 'ขอเงินจองคืนกรณีไม่ได้รถ', parent: '43',
        },
        {
          row: '273', id: '78', name: 'ราคาสูงกว่าที่ตกลง', parent: '43',
        },
        {
          row: '274', id: '88', name: 'ศูนย์บริการซ่อม/อู่ซ่อมรถ ไม่ซ่อมรถตามที่ตกลง', parent: '43',
        },
        {
          row: '275', id: '95', name: 'ตรวจสอบการทำงานของเจ้าหน้าที่', parent: '43',
        },
        {
          row: '276', id: '120', name: 'ฉ้อโกง', parent: '43',
        },
        {
          row: '277', id: '122', name: 'ตรวจสอบข้อเท็จจริง', parent: '43',
        },
        {
          row: '278', id: '154', name: 'ขอให้ชดใช้ค่าเสียหาย', parent: '43',
        },
        {
          row: '279', id: '157', name: 'พฤติกรรมการทวงหนี้', parent: '43',
        },
        {
          row: '280', id: '159', name: 'ขอคำปรึกษา', parent: '43',
        },
        {
          row: '281', id: '160', name: 'จัดไฟแนนซ์ไม่ผ่าน,ได้ไม่เต็มจำนวน', parent: '43',
        },
        {
          row: '282', id: '162', name: 'รถสูญหาย', parent: '43',
        },
        {
          row: '283', id: '163', name: 'ขอปิดบัญชี', parent: '43',
        },
        {
          row: '284', id: '171', name: 'ไม่ได้รับป้ายทะเบียน', parent: '43',
        },
        {
          row: '285', id: '178', name: 'คิดค่าบริการสูงเกินจริง', parent: '43',
        },
        {
          row: '286', id: '179', name: 'ค่าติดตามสูงเกินจริง', parent: '43',
        },
        {
          row: '287', id: '188', name: 'ยึดรถคืน', parent: '43',
        },
        {
          row: '288', id: '81', name: 'ตรวจสอบค่าชำระงวด', parent: '43',
        },
        {
          row: '289', id: '91', name: 'ยกเลิกสัญญาและขอเงินคืน', parent: '43',
        },
        {
          row: '290', id: '174', name: 'ไม่ได้รับเล่มทะเบียน', parent: '43',
        },
        {
          row: '291', id: '15', name: 'ไม่ดำเนินการโอนกรรมสิทธิ์', parent: '43',
        },
        {
          row: '292', id: '20', name: 'ไม่เป็นไปตามที่ระบุไว้ในสัญญา', parent: '43',
        },
        {
          row: '293', id: '37', name: 'ตรวจสอบค่าธรรมเนียม', parent: '43',
        },
        {
          row: '294', id: '39', name: 'ผิดสัญญาเช่าซื้อ', parent: '43',
        },
        {
          row: '295', id: '1', name: 'ผิดไปจากฉลากที่ระบุ', parent: '43',
        },
        {
          row: '296', id: '1', name: 'ผิดไปจากฉลากที่ระบุ', parent: '44',
        },
        {
          row: '297', id: '65', name: 'ตรวจสอบค่าโดยสาร/ค่าเช่า', parent: '44',
        },
        {
          row: '298', id: '70', name: 'ค่าปรับสูง', parent: '44',
        },
        {
          row: '299', id: '71', name: 'ค้างค่างวด/คืนรถ/ส่วนต่างสูง', parent: '44',
        },
        {
          row: '300', id: '74', name: 'ชำรุด', parent: '44',
        },
        {
          row: '301', id: '76', name: 'ขอประนอมหนี้/ไม่มีเงินจ่าย', parent: '44',
        },
        {
          row: '302', id: '78', name: 'ราคาสูงกว่าที่ตกลง', parent: '44',
        },
        {
          row: '303', id: '88', name: 'ศูนย์บริการซ่อม/อู่ซ่อมรถ ไม่ซ่อมรถตามที่ตกลง', parent: '44',
        },
        {
          row: '304', id: '95', name: 'ตรวจสอบการทำงานของเจ้าหน้าที่', parent: '44',
        },
        {
          row: '305', id: '120', name: 'ฉ้อโกง', parent: '44',
        },
        {
          row: '306', id: '122', name: 'ตรวจสอบข้อเท็จจริง', parent: '44',
        },
        {
          row: '307', id: '154', name: 'ขอให้ชดใช้ค่าเสียหาย', parent: '44',
        },
        {
          row: '308', id: '157', name: 'พฤติกรรมการทวงหนี้', parent: '44',
        },
        {
          row: '309', id: '159', name: 'ขอคำปรึกษา', parent: '44',
        },
        {
          row: '310', id: '161', name: 'ขอเงินจองคืน', parent: '44',
        },
        {
          row: '311', id: '162', name: 'รถสูญหาย', parent: '44',
        },
        {
          row: '312', id: '163', name: 'ขอปิดบัญชี', parent: '44',
        },
        {
          row: '313', id: '171', name: 'ไม่ได้รับป้ายทะเบียน', parent: '44',
        },
        {
          row: '314', id: '178', name: 'คิดค่าบริการสูงเกินจริง', parent: '44',
        },
        {
          row: '315', id: '179', name: 'ค่าติดตามสูงเกินจริง', parent: '44',
        },
        {
          row: '316', id: '188', name: 'ยึดรถคืน', parent: '44',
        },
        {
          row: '317', id: '81', name: 'ตรวจสอบค่าชำระงวด', parent: '44',
        },
        {
          row: '318', id: '91', name: 'ยกเลิกสัญญาและขอเงินคืน', parent: '44',
        },
        {
          row: '319', id: '174', name: 'ไม่ได้รับเล่มทะเบียน', parent: '44',
        },
        {
          row: '320', id: '15', name: 'ไม่ดำเนินการโอนกรรมสิทธิ์', parent: '44',
        },
        {
          row: '321', id: '20', name: 'ไม่เป็นไปตามที่ระบุไว้ในสัญญา', parent: '44',
        },
        {
          row: '322', id: '37', name: 'ตรวจสอบค่าธรรมเนียม', parent: '44',
        },
        {
          row: '323', id: '39', name: 'ผิดสัญญาเช่าซื้อ', parent: '44',
        },
        {
          row: '324', id: '43', name: 'จัดไฟแนนซ์ไม่ผ่าน', parent: '44',
        },
        {
          row: '325', id: '37', name: 'ตรวจสอบค่าธรรมเนียม', parent: '45',
        },
        {
          row: '326', id: '108', name: 'ไม่มีสินค้าตามโปรโมชั่น', parent: '46',
        },
        {
          row: '327', id: '199', name: 'นำสินค้าหมดอายุมาจำหน่าย', parent: '46',
        },
        {
          row: '328', id: '63', name: 'อาหารเป็นพิษ /เน่าเสีย', parent: '46',
        },
        {
          row: '329', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '46',
        },
        {
          row: '330', id: '198', name: 'ทรัพย์สินสูญหายภายในห้าง', parent: '46',
        },
        {
          row: '331', id: '72', name: 'ขอเงินประกันคืน', parent: '47',
        },
        {
          row: '332', id: '74', name: 'ชำรุด', parent: '47',
        },
        {
          row: '333', id: '83', name: 'ค่าใช้บริการสูงเกินความจริง', parent: '47',
        },
        {
          row: '334', id: '84', name: 'ซ่อมล่าช้า', parent: '47',
        },
        {
          row: '335', id: '85', name: 'อื่นๆ', parent: '47',
        },
        {
          row: '336', id: '190', name: 'ค้างชำระ', parent: '47',
        },
        {
          row: '337', id: '82', name: 'ตรวจสอบใบแจ้งหนี้', parent: '47',
        },
        {
          row: '338', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '47',
        },
        {
          row: '339', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '48',
        },
        {
          row: '340', id: '91', name: 'ยกเลิกสัญญาและขอเงินคืน', parent: '48',
        },
        {
          row: '341', id: '112', name: 'ขอเงินค่ามัดจำคืน', parent: '49',
        },
        {
          row: '342', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '49',
        },
        {
          row: '343', id: '94', name: 'เรียกร้องค่าชดเชยเพิ่ม', parent: '50',
        },
        {
          row: '344', id: '106', name: 'ปรับแต่งภาพเกินทำให้เกิดความเสียหาย', parent: '51',
        },
        {
          row: '345', id: '120', name: 'ฉ้อโกง', parent: '51',
        },
        {
          row: '346', id: '119', name: 'เลือกให้บริการ', parent: '52',
        },
        {
          row: '347', id: '263', name: 'ไม่ได้รับความเป็นธรรมจากการใช้บริการ', parent: '53',
        },
        {
          row: '348', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '53',
        },
        {
          row: '349', id: '141', name: 'ตรวจสอบอายุของสัตว์เลี้ยง', parent: '54',
        },
        {
          row: '350', id: '46', name: 'ตรวจสอบการเรียกเก็บอัตราดอกเบี้ย', parent: '55',
        },
        {
          row: '351', id: '37', name: 'ตรวจสอบค่าธรรมเนียม', parent: '56',
        },
        {
          row: '352', id: '65', name: 'ตรวจสอบค่าโดยสาร/ค่าเช่า', parent: '57',
        },
        {
          row: '353', id: '122', name: 'ตรวจสอบข้อเท็จจริง', parent: '57',
        },
        {
          row: '354', id: '132', name: 'เปลี่ยนแปลงเวลาไม่ได้', parent: '57',
        },
        {
          row: '355', id: '40', name: 'อัตราดอกเบี้ยสูงเกินไป', parent: '57',
        },
        {
          row: '356', id: '65', name: 'ตรวจสอบค่าโดยสาร/ค่าเช่า', parent: '58',
        },
        {
          row: '357', id: '122', name: 'ตรวจสอบข้อเท็จจริง', parent: '58',
        },
        {
          row: '358', id: '95', name: 'ตรวจสอบการทำงานของเจ้าหน้าที่', parent: '59',
        },
        {
          row: '359', id: '76', name: 'ขอประนอมหนี้/ไม่มีเงินจ่าย', parent: '60',
        },
        {
          row: '360', id: '151', name: 'ค้างค่างวด', parent: '60',
        },
        {
          row: '361', id: '153', name: 'ไม่ชำระหนี้', parent: '60',
        },
        {
          row: '362', id: '157', name: 'พฤติกรรมการทวงหนี้', parent: '60',
        },
        {
          row: '363', id: '159', name: 'ขอคำปรึกษา', parent: '60',
        },
        {
          row: '364', id: '163', name: 'ขอปิดบัญชี', parent: '60',
        },
        {
          row: '365', id: '172', name: 'ค่าปรับล่าช้า', parent: '60',
        },
        {
          row: '366', id: '175', name: 'ขอให้แก้ไขข้อมูลเครดิตแห่งชาติ', parent: '60',
        },
        {
          row: '367', id: '18', name: 'กู้ไม่ผ่าน, กู้ได้ไม่เต็มจำนวนที่ขอกู้', parent: '60',
        },
        {
          row: '368', id: '37', name: 'ตรวจสอบค่าธรรมเนียม', parent: '60',
        },
        {
          row: '369', id: '40', name: 'อัตราดอกเบี้ยสูงเกินไป', parent: '60',
        },
        {
          row: '370', id: '47', name: 'ขอให้ลดอัตราดอกเบี้ย', parent: '60',
        },
        {
          row: '371', id: '264', name: 'รอปรับปรุงโครงสร้างหนี้', parent: '60',
        },
        {
          row: '372', id: '76', name: 'ขอประนอมหนี้/ไม่มีเงินจ่าย', parent: '61',
        },
        {
          row: '373', id: '151', name: 'ค้างค่างวด', parent: '61',
        },
        {
          row: '374', id: '153', name: 'ไม่ชำระหนี้', parent: '61',
        },
        {
          row: '375', id: '157', name: 'พฤติกรรมการทวงหนี้', parent: '61',
        },
        {
          row: '376', id: '159', name: 'ขอคำปรึกษา', parent: '61',
        },
        {
          row: '377', id: '163', name: 'ขอปิดบัญชี', parent: '61',
        },
        {
          row: '378', id: '172', name: 'ค่าปรับล่าช้า', parent: '61',
        },
        {
          row: '379', id: '175', name: 'ขอให้แก้ไขข้อมูลเครดิตแห่งชาติ', parent: '61',
        },
        {
          row: '380', id: '18', name: 'กู้ไม่ผ่าน, กู้ได้ไม่เต็มจำนวนที่ขอกู้', parent: '61',
        },
        {
          row: '381', id: '37', name: 'ตรวจสอบค่าธรรมเนียม', parent: '61',
        },
        {
          row: '382', id: '40', name: 'อัตราดอกเบี้ยสูงเกินไป', parent: '61',
        },
        {
          row: '383', id: '47', name: 'ขอให้ลดอัตราดอกเบี้ย', parent: '61',
        },
        {
          row: '384', id: '264', name: 'รอปรับปรุงโครงสร้างหนี้', parent: '61',
        },
        {
          row: '385', id: '209', name: 'ได้รับผลกระทบ/บาดเจ็บจากการเสริมความงาม', parent: '62',
        },
        {
          row: '386', id: '210', name: ' คลินิก/ร้าน ปิดกิจการ', parent: '62',
        },
        {
          row: '387', id: '37', name: 'ตรวจสอบค่าธรรมเนียม', parent: '64',
        },
        {
          row: '388', id: '64', name: 'สินค้าชำรุด', parent: '65',
        },
        {
          row: '389', id: '105', name: 'สั่งซื้อสินค้าแล้วไม่ได้รับสินค้า', parent: '65',
        },
        {
          row: '390', id: '125', name: 'ไม่ประกันสินค้า', parent: '65',
        },
        {
          row: '391', id: '258', name: 'ผิดไปจากฉลากที่ระบุ', parent: '65',
        },
        {
          row: '392', id: '5', name: 'การโฆษณาอาจก่อให้เกิดความเข้าใจผิด', parent: '65',
        },
        {
          row: '393', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '65',
        },
        {
          row: '394', id: '95', name: 'ตรวจสอบการทำงานของเจ้าหน้าที่', parent: '66',
        },
        {
          row: '395', id: '97', name: 'ราคาไม่เหมาะสม', parent: '66',
        },
        {
          row: '396', id: '110', name: 'เลือกปฏิบัติ', parent: '66',
        },
        {
          row: '397', id: '64', name: 'สินค้าชำรุด', parent: '67',
        },
        {
          row: '398', id: '105', name: 'สั่งซื้อสินค้าแล้วไม่ได้รับสินค้า', parent: '67',
        },
        {
          row: '399', id: '258', name: 'ผิดไปจากฉลากที่ระบุ', parent: '67',
        },
        {
          row: '400', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '67',
        },
        {
          row: '401', id: '5', name: 'การโฆษณาอาจก่อให้เกิดความเข้าใจผิด', parent: '67',
        },
        {
          row: '402', id: '1', name: 'ผิดไปจากฉลากที่ระบุ', parent: '67',
        },
        {
          row: '403', id: '100', name: 'สัญญาณ Hispeed Internet ช้า', parent: '68',
        },
        {
          row: '404', id: '126', name: 'ค่าบริการเกินจริง', parent: '68',
        },
        {
          row: '405', id: '127', name: 'โฆษณาเกินจริง', parent: '68',
        },
        {
          row: '406', id: '159', name: 'ขอคำปรึกษา', parent: '68',
        },
        {
          row: '407', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '68',
        },
        {
          row: '408', id: '79', name: 'ยกเลิกสัญญา', parent: '69',
        },
        {
          row: '409', id: '117', name: 'ไม่แจ้งสมาชิกให้ทราบถึงค่าบริการต่ออายุสมาชิก', parent: '69',
        },
        {
          row: '410', id: '91', name: 'ยกเลิกสัญญาและขอเงินคืน', parent: '69',
        },
        {
          row: '411', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '69',
        },
        {
          row: '412', id: '88', name: 'ศูนย์บริการซ่อม/อู่ซ่อมรถ ไม่ซ่อมรถตามที่ตกลง', parent: '71',
        },
        {
          row: '413', id: '104', name: 'ราคาซ่อม/อะไหล่ เกินความเป็นจริง', parent: '71',
        },
        {
          row: '414', id: '122', name: 'ตรวจสอบข้อเท็จจริง', parent: '71',
        },
        {
          row: '415', id: '140', name: 'ซ่อมไม่ได้มาตรฐาน', parent: '71',
        },
        {
          row: '416', id: '189', name: 'ไม่ออกหลักฐานการรับเงิน', parent: '71',
        },
        {
          row: '417', id: '97', name: 'ราคาไม่เหมาะสม', parent: '72',
        },
        {
          row: '418', id: '128', name: 'ไม่สะอาด', parent: '72',
        },
        {
          row: '419', id: '145', name: 'ทรัพย์สินสูญหาย', parent: '72',
        },
        {
          row: '420', id: '197', name: 'ไม่ดำเนินการตามเงื่อนไข,สิทธิประโยชน์', parent: '72',
        },
        {
          row: '421', id: '63', name: 'อาหารเป็นพิษ /เน่าเสีย', parent: '72',
        },
        {
          row: '422', id: '267', name: 'อื่นๆ', parent: '72',
        },
        {
          row: '423', id: '96', name: 'ไม่ดำเนินการตามสัญญา', parent: '73',
        },
        {
          row: '424', id: '112', name: 'ขอเงินค่ามัดจำคืน', parent: '73',
        },
        {
          row: '425', id: '87', name: 'ไม่ได้มาตรฐาน', parent: '74',
        },
        {
          row: '426', id: '124', name: 'บริการหลังการขายไม่เป็นตามสัญญา', parent: '74',
        },
        {
          row: '427', id: '64', name: 'สินค้าชำรุด', parent: '75',
        },
        {
          row: '428', id: '74', name: 'ชำรุด', parent: '75',
        },
        {
          row: '429', id: '87', name: 'ไม่ได้มาตรฐาน', parent: '75',
        },
        {
          row: '430', id: '97', name: 'ราคาไม่เหมาะสม', parent: '75',
        },
        {
          row: '431', id: '105', name: 'สั่งซื้อสินค้าแล้วไม่ได้รับสินค้า', parent: '75',
        },
        {
          row: '432', id: '127', name: 'โฆษณาเกินจริง', parent: '75',
        },
        {
          row: '433', id: '196', name: 'ตรวจสอบอัตราดอกเบี้ย', parent: '75',
        },
        {
          row: '434', id: '96', name: 'ไม่ดำเนินการตามสัญญา', parent: '76',
        },
        {
          row: '435', id: '84', name: 'ซ่อมล่าช้า', parent: '77',
        },
        {
          row: '436', id: '87', name: 'ไม่ได้มาตรฐาน', parent: '78',
        },
        {
          row: '437', id: '203', name: 'ยกเลิกการสั่งซื้อ/การจอง', parent: '78',
        },
        {
          row: '438', id: '202', name: 'สินค้าสูญหายระหว่างการขนส่ง', parent: '79',
        },
        {
          row: '439', id: '64', name: 'สินค้าชำรุด', parent: '79',
        },
        {
          row: '440', id: '65', name: 'ตรวจสอบค่าโดยสาร/ค่าเช่า', parent: '80',
        },
        {
          row: '441', id: '114', name: 'ส่งเสียงดังรบกวน', parent: '81',
        },
        {
          row: '442', id: '65', name: 'ตรวจสอบค่าโดยสาร/ค่าเช่า', parent: '82',
        },
        {
          row: '443', id: '260', name: 'ได้รับความเดือดร้อนจากธุรกิจขายตรง', parent: '83',
        },
        {
          row: '444', id: '259', name: 'ได้รับความเสียหายจากการขายสินค้า', parent: '83',
        },
        {
          row: '445', id: '65', name: 'ตรวจสอบค่าโดยสาร/ค่าเช่า', parent: '85',
        },
        {
          row: '446', id: '37', name: 'ตรวจสอบค่าธรรมเนียม', parent: '86',
        },
        {
          row: '447', id: '40', name: 'อัตราดอกเบี้ยสูงเกินไป', parent: '86',
        },
        {
          row: '448', id: '47', name: 'ขอให้ลดอัตราดอกเบี้ย', parent: '86',
        },
        {
          row: '449', id: '115', name: 'ฝุ่นละอองเป็นพิษ', parent: '87',
        },
        {
          row: '450', id: '194', name: 'ส่งกลิ่นเหม็นรบกวน', parent: '87',
        },
        {
          row: '451', id: '72', name: 'ขอเงินประกันคืน', parent: '88',
        },
        {
          row: '452', id: '241', name: 'เรียกเก็บค่าสาธารณูปโภคสูงเกินไป', parent: '88',
        },
        {
          row: '453', id: '242', name: 'เฟอร์นิเจอร์ชำรุดบกพร่องก่อนเข้าอยู่อาศัย', parent: '88',
        },
        {
          row: '454', id: '243', name: 'อัตราค่าน้ำประปา/ค่าไฟฟ้าสูงเกินจริง', parent: '88',
        },
        {
          row: '455', id: '246', name: 'อัตราค่าเช่าสูงเกินควร', parent: '88',
        },
        {
          row: '456', id: '169', name: 'ถูกโจรกรรมทรัพย์สิน/ชดใช้ค่าเสียหาย', parent: '88',
        },
        {
          row: '457', id: '244', name: 'เรียกเก็บอัตราคาเช่าเกินกว่าที่สัญญากำหนด', parent: '88',
        },
        {
          row: '458', id: '245', name: 'ไม่คืนเงินค่ามัดจำ/ค่าจอง', parent: '88',
        },
        {
          row: '459', id: '14', name: 'ไม่ดำเนินการตามที่โฆษณา', parent: '88',
        },
        {
          row: '460', id: '247', name: 'ไม่ให้สัญญาเช่า/ไม่ส่งมอบสัญญาคู่ฉบับให้', parent: '88',
        },
        {
          row: '461', id: '248', name: 'บอกเลิกสัญญาก่อนครบกำหนด', parent: '88',
        },
        {
          row: '462', id: '37', name: 'ตรวจสอบค่าธรรมเนียม', parent: '89',
        },
        {
          row: '463', id: '126', name: 'ค่าบริการเกินจริง', parent: '90',
        },
        {
          row: '464', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '90',
        },
        {
          row: '465', id: '50', name: 'เรื่องมิเตอร์ไฟฟ้า', parent: '90',
        },
        {
          row: '466', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '91',
        },
        {
          row: '467', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '92',
        },
        {
          row: '468', id: '99', name: 'ไม่ได้รับความเป็นธรรม', parent: '92',
        },
        {
          row: '469', id: '95', name: 'ตรวจสอบการทำงานของเจ้าหน้าที่', parent: '93',
        },
        {
          row: '470', id: '103', name: 'ใบเสร็จรับเงินไม่ตรงกับกรมธรรม์', parent: '93',
        },
        {
          row: '471', id: '139', name: 'ไม่ยอมให้ยกเลิกกรมธรรม์', parent: '93',
        },
        {
          row: '472', id: '92', name: 'ปฏิเสธการจ่ายค่าสินไหม', parent: '93',
        },
        {
          row: '473', id: '258', name: 'ผิดไปจากฉลากที่ระบุ', parent: '93',
        },
        {
          row: '474', id: '5', name: 'การโฆษณาอาจก่อให้เกิดความเข้าใจผิด', parent: '93',
        },
        {
          row: '475', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '93',
        },
        {
          row: '476', id: '64', name: 'สินค้าชำรุด', parent: '94',
        },
        {
          row: '477', id: '105', name: 'สั่งซื้อสินค้าแล้วไม่ได้รับสินค้า', parent: '94',
        },
        {
          row: '478', id: '258', name: 'ผิดไปจากฉลากที่ระบุ', parent: '94',
        },
        {
          row: '479', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '94',
        },
        {
          row: '480', id: '5', name: 'การโฆษณาอาจก่อให้เกิดความเข้าใจผิด', parent: '94',
        },
        {
          row: '481', id: '64', name: 'สินค้าชำรุด', parent: '95',
        },
        {
          row: '482', id: '105', name: 'สั่งซื้อสินค้าแล้วไม่ได้รับสินค้า', parent: '95',
        },
        {
          row: '483', id: '122', name: 'ตรวจสอบข้อเท็จจริง', parent: '95',
        },
        {
          row: '484', id: '129', name: 'ราคาผันผวน', parent: '95',
        },
        {
          row: '485', id: '258', name: 'ผิดไปจากฉลากที่ระบุ', parent: '95',
        },
        {
          row: '486', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '95',
        },
        {
          row: '487', id: '5', name: 'การโฆษณาอาจก่อให้เกิดความเข้าใจผิด', parent: '95',
        },
        {
          row: '488', id: '64', name: 'สินค้าชำรุด', parent: '96',
        },
        {
          row: '489', id: '97', name: 'ราคาไม่เหมาะสม', parent: '96',
        },
        {
          row: '490', id: '99', name: 'ไม่ได้รับความเป็นธรรม', parent: '96',
        },
        {
          row: '491', id: '105', name: 'สั่งซื้อสินค้าแล้วไม่ได้รับสินค้า', parent: '96',
        },
        {
          row: '492', id: '108', name: 'ไม่มีสินค้าตามโปรโมชั่น', parent: '96',
        },
        {
          row: '493', id: '122', name: 'ตรวจสอบข้อเท็จจริง', parent: '96',
        },
        {
          row: '494', id: '127', name: 'โฆษณาเกินจริง', parent: '96',
        },
        {
          row: '495', id: '54', name: 'ตรวจสอบการทำงานของบริษัท', parent: '96',
        },
        {
          row: '496', id: '261', name: 'ขอเงินคืน', parent: '96',
        },
        {
          row: '497', id: '1', name: 'ผิดไปจากฉลากที่ระบุ', parent: '96',
        },
        {
          row: '498', id: '99', name: 'ไม่ได้รับความเป็นธรรม', parent: '99',
        },
        {
          row: '499', id: '105', name: 'สั่งซื้อสินค้าแล้วไม่ได้รับสินค้า', parent: '100',
        },
        {
          row: '500', id: '127', name: 'โฆษณาเกินจริง', parent: '100',
        },
        {
          row: '501', id: '130', name: 'ราคาขายสูงกว่าที่ระบุในฉลาก', parent: '100',
        },
        {
          row: '502', id: '138', name: 'ตรวจสอบราคาผลิตภัณฑ์', parent: '100',
        },
        {
          row: '503', id: '142', name: 'ราคาสินค้าไม่ตรงกับป้ายแสดงราคา', parent: '100',
        },
        {
          row: '504', id: '150', name: 'ตรวจสอบคุณภาพสินค้า', parent: '100',
        },
        {
          row: '505', id: '258', name: 'ผิดไปจากฉลากที่ระบุ', parent: '100',
        },
        {
          row: '506', id: '110', name: 'เลือกปฏิบัติ', parent: '101',
        },
        {
          row: '507', id: '96', name: 'ไม่ดำเนินการตามสัญญา', parent: '102',
        },
        {
          row: '508', id: '137', name: 'ไม่ชำระค่าบริการ', parent: '103',
        },
        {
          row: '509', id: '146', name: 'ขอคืนเงินมัดจำค่าถังแก๊ส', parent: '105',
        },
        {
          row: '510', id: '176', name: 'ตรวจสอบพฤติกรรม', parent: '105',
        },
        {
          row: '511', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '106',
        },
        {
          row: '512', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '106',
        },
        {
          row: '513', id: '45', name: 'ตรวจสอบการให้บริการ', parent: '106',
        },
        {
          row: '514', id: '261', name: 'ขอเงินคืน', parent: '106',
        },
        {
          row: '515', id: '99', name: 'ไม่ได้รับความเป็นธรรม', parent: '106',
        },
        {
          row: '516', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '107',
        },
        {
          row: '517', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '107',
        },
        {
          row: '518', id: '45', name: 'ตรวจสอบการให้บริการ', parent: '107',
        },
        {
          row: '519', id: '261', name: 'ขอเงินคืน', parent: '107',
        },
        {
          row: '520', id: '99', name: 'ไม่ได้รับความเป็นธรรม', parent: '107',
        },
        {
          row: '521', id: '86', name: 'ขอคืนค่าโดยสาร', parent: '108',
        },
        {
          row: '522', id: '96', name: 'ไม่ดำเนินการตามสัญญา', parent: '108',
        },
        {
          row: '523', id: '99', name: 'ไม่ได้รับความเป็นธรรม', parent: '108',
        },
        {
          row: '524', id: '91', name: 'ยกเลิกสัญญาและขอเงินคืน', parent: '108',
        },
        {
          row: '525', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '108',
        },
        {
          row: '526', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '108',
        },
        {
          row: '527', id: '249', name: 'ขอให้ตรวจสอบ', parent: '109',
        },
        {
          row: '528', id: '232', name: 'ขอให้แก้ไขเพิ่มเติมสัญญา', parent: '109',
        },
        {
          row: '529', id: '159', name: 'ขอคำปรึกษา', parent: '109',
        },
        {
          row: '530', id: '167', name: 'ก่อสร้างไม่แล้วเสร็จ', parent: '109',
        },
        {
          row: '531', id: '21', name: 'มีการก่อสร้างแล้วเสร็จแต่เก็บงานไม่เรียบร้อย', parent: '109',
        },
        {
          row: '532', id: '12', name: 'ไม่ปลูกสร้าง', parent: '109',
        },
        {
          row: '533', id: '14', name: 'ไม่ดำเนินการตามที่โฆษณา', parent: '109',
        },
        {
          row: '534', id: '250', name: 'ไม่ดำเนินการโอนตามกรรมสิทธิ์', parent: '109',
        },
        {
          row: '535', id: '251', name: 'ไม่ดำเนินการแบ่งแยกโฉนดที่ดิน', parent: '109',
        },
        {
          row: '536', id: '252', name: 'มีการชำรุดหลังปลูกสร้างของบ้าน/บ้านทรุด/รอยร้าว/ผนังแตกแยก', parent: '109',
        },
        {
          row: '537', id: '234', name: 'สถาบันการเงินไม่อนุมัติสินเชื่อ', parent: '109',
        },
        {
          row: '538', id: '223', name: 'สถาบันการเงินอนุมัติสินเชื่อ ไม่เต็มจำนวนเงิน', parent: '109',
        },
        {
          row: '539', id: '236', name: 'จำนวนเนื้อที่ไม่ตรงกับที่โฆษณา/ใบจอง/สัญญา', parent: '109',
        },
        {
          row: '540', id: '237', name: 'ก่อสร้างไม่ถูกต้องตามแปลนที่ได้รับอนุญาตตามราชการ', parent: '109',
        },
        {
          row: '541', id: '225', name: 'ก่อสร้างไม่เหมือนบ้านตัวอย่าง', parent: '109',
        },
        {
          row: '542', id: '253', name: 'แบบสัญญาไม่เป็นไปตามที่กฎหมายกำหนด ต้องการให้ผู้ประกอบการแก้ไขแบบสัญญาให้เป็นไปตามมาตรฐานตามที่กฎหมายกำหนด', parent: '109',
        },
        {
          row: '543', id: '227', name: 'การบริหารงานของนิติบุคคลหมู่บ้านจัดสรรไม่โปร่งใส', parent: '109',
        },
        {
          row: '544', id: '19', name: 'ไม่จัดทำสาธารณูปโภคในโครงการ', parent: '109',
        },
        {
          row: '545', id: '229', name: 'ไม่ดูแลและพัฒนาสาธารณูปโภคในโครงการ ', parent: '109',
        },
        {
          row: '546', id: '230', name: 'ปิดทางเข้าออกโครงการ', parent: '109',
        },
        {
          row: '547', id: '231', name: 'ผู้ประกอบการไม่ชำระค่าปรับล่าช้า', parent: '109',
        },
        {
          row: '548', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '109',
        },
        {
          row: '549', id: '159', name: 'ขอคำปรึกษา', parent: '111',
        },
        {
          row: '550', id: '254', name: 'ไม่คืนเงินค่าจอง/เงินทำสัญญา', parent: '111',
        },
        {
          row: '551', id: '14', name: 'ไม่ดำเนินการตามที่โฆษณา', parent: '111',
        },
        {
          row: '552', id: '250', name: 'ไม่ดำเนินการโอนตามกรรมสิทธิ์', parent: '111',
        },
        {
          row: '553', id: '251', name: 'ไม่ดำเนินการแบ่งแยกโฉนดที่ดิน', parent: '111',
        },
        {
          row: '554', id: '234', name: 'สถาบันการเงินไม่อนุมัติสินเชื่อ', parent: '111',
        },
        {
          row: '555', id: '223', name: 'สถาบันการเงินอนุมัติสินเชื่อ ไม่เต็มจำนวนเงิน', parent: '111',
        },
        {
          row: '556', id: '236', name: 'จำนวนเนื้อที่ไม่ตรงกับที่โฆษณา/ใบจอง/สัญญา', parent: '111',
        },
        {
          row: '557', id: '253', name: 'แบบสัญญาไม่เป็นไปตามที่กฎหมายกำหนด ต้องการให้ผู้ประกอบการแก้ไขแบบสัญญาให้เป็นไปตามมาตรฐานตามที่กฎหมายกำหนด', parent: '111',
        },
        {
          row: '558', id: '19', name: 'ไม่จัดทำสาธารณูปโภคในโครงการ', parent: '111',
        },
        {
          row: '559', id: '229', name: 'ไม่ดูแลและพัฒนาสาธารณูปโภคในโครงการ ', parent: '111',
        },
        {
          row: '560', id: '230', name: 'ปิดทางเข้าออกโครงการ', parent: '111',
        },
        {
          row: '561', id: '217', name: 'สัญญาไม่เป็นธรรม', parent: '112',
        },
        {
          row: '562', id: '218', name: 'จองที่พักไม่ได้', parent: '112',
        },
        {
          row: '563', id: '219', name: 'ที่พักไม่เป็นไปตามโฆษณา', parent: '112',
        },
        {
          row: '564', id: '91', name: 'ยกเลิกสัญญาและขอเงินคืน', parent: '112',
        },
        {
          row: '565', id: '265', name: 'ไม่สามารถเข้าใช้บริการได้ตามสัญญา', parent: '112',
        },
        {
          row: '566', id: '66', name: 'ยกเลิกเที่ยวบิน', parent: '113',
        },
        {
          row: '567', id: '67', name: 'เที่ยวบินล่าช้า', parent: '113',
        },
        {
          row: '568', id: '68', name: 'กระเป๋าเดินทางสูญหาย/ชำรุดเสียหาย', parent: '113',
        },
        {
          row: '569', id: '69', name: 'คิดค่าตั๋วไม่เป็นธรรม', parent: '113',
        },
        {
          row: '570', id: '86', name: 'ขอคืนค่าโดยสาร', parent: '113',
        },
        {
          row: '571', id: '61', name: 'ไม่คืนเงินค่าโดยสารตามกำหนด', parent: '113',
        },
        {
          row: '572', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '113',
        },
        {
          row: '573', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '113',
        },
        {
          row: '574', id: '45', name: 'ตรวจสอบการให้บริการ', parent: '113',
        },
        {
          row: '575', id: '213', name: 'ผู้ขายตั๋วฉ้อโกง', parent: '113',
        },
        {
          row: '576', id: '214', name: 'ผู้โดยสารไม่สามารถเดินทางได้', parent: '113',
        },
        {
          row: '577', id: '215', name: 'ตั๋วถูกยกเลิก', parent: '113',
        },
        {
          row: '578', id: '216', name: 'ตั๋วถูกเลื่อน', parent: '113',
        },
        {
          row: '579', id: '65', name: 'ตรวจสอบค่าโดยสาร/ค่าเช่า', parent: '114',
        },
        {
          row: '580', id: '74', name: 'ชำรุด', parent: '114',
        },
        {
          row: '581', id: '96', name: 'ไม่ดำเนินการตามสัญญา', parent: '114',
        },
        {
          row: '582', id: '260', name: 'ได้รับความเดือดร้อนจากธุรกิจขายตรง', parent: '117',
        },
        {
          row: '583', id: '259', name: 'ได้รับความเสียหายจากการขายสินค้า', parent: '117',
        },
        {
          row: '584', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '118',
        },
        {
          row: '585', id: '4', name: 'การโฆษณาเป็นเท็จ/เกินความเป็นจริง', parent: '118',
        },
        {
          row: '586', id: '261', name: 'ขอเงินคืน', parent: '118',
        },
        {
          row: '587', id: '266', name: 'ไม่สามารถใช้บริการได้ตามที่ตกลงไว้', parent: '118',
        },
        {
          row: '588', id: '65', name: 'ตรวจสอบค่าโดยสาร/ค่าเช่า', parent: '119',
        },
        {
          row: '589', id: '75', name: 'ค่าปรับสูง/ดอกเบี้ยล่าช้าสูง', parent: '119',
        },
        {
          row: '590', id: '118', name: 'ปิดบัญชีสินค้า', parent: '119',
        },
        {
          row: '591', id: '188', name: 'ยึดรถคืน', parent: '119',
        },
        {
          row: '592', id: '217', name: 'สัญญาไม่เป็นธรรม', parent: '119',
        },
        {
          row: '593', id: '81', name: 'ตรวจสอบค่าชำระงวด', parent: '119',
        },
        {
          row: '594', id: '65', name: 'ตรวจสอบค่าโดยสาร/ค่าเช่า', parent: '120',
        },
        {
          row: '595', id: '45', name: 'ตรวจสอบการให้บริการ', parent: '120',
        },
        {
          row: '596', id: '122', name: 'ตรวจสอบข้อเท็จจริง', parent: '121',
        },
        {
          row: '597', id: '37', name: 'ตรวจสอบค่าธรรมเนียม', parent: '121',
        },
        {
          row: '598', id: '40', name: 'อัตราดอกเบี้ยสูงเกินไป', parent: '121',
        },
        {
          row: '599', id: '47', name: 'ขอให้ลดอัตราดอกเบี้ย', parent: '121',
        },
        {
          row: '600', id: '116', name: 'น้ำเน่าเสีย/กลิ่นเหม็น', parent: '122',
        },
        {
          row: '601', id: '79', name: 'ยกเลิกสัญญา', parent: '125',
        },
        {
          row: '602', id: '184', name: 'ตรวจสอบ/ข้อมูลไม่ตรงกัน', parent: '125',
        },
        {
          row: '603', id: '185', name: 'ไม่ต่อสัญญาเช่า', parent: '125',
        },
        {
          row: '604', id: '13', name: 'มีการก่อสร้างแต่ไม่แล้วเสร็จ', parent: '125',
        },
        {
          row: '605', id: '62', name: 'ไม่คืนเงินมัดจำ/ค่าจอง', parent: '125',
        },
        {
          row: '606', id: '14', name: 'ไม่ดำเนินการตามที่โฆษณา', parent: '125',
        },
        {
          row: '607', id: '18', name: 'กู้ไม่ผ่าน, กู้ได้ไม่เต็มจำนวนที่ขอกู้', parent: '125',
        },
        {
          row: '608', id: '20', name: 'ไม่เป็นไปตามที่ระบุไว้ในสัญญา', parent: '125',
        },
        {
          row: '609', id: '22', name: 'จำนวนที่ดินในสัญญาไม่ตรงกับใบจองและแผ่นพับโฆษณา', parent: '125',
        },
        {
          row: '610', id: '25', name: 'ก่อสร้างไม่ถูกต้องตามแปลนที่ได้รับอนุญาต', parent: '125',
        },
        {
          row: '611', id: '27', name: 'บริษัททุบแผงก่อนหมดสัญญาเช่า', parent: '125',
        },
        {
          row: '612', id: '29', name: 'ค่าเช่าสูงเกินไป', parent: '125',
        },
        {
          row: '613', id: '30', name: 'ไม่ให้สัญญาเช่า', parent: '125',
        },
        {
          row: '614', id: '19', name: 'ไม่จัดทำสาธารณูปโภคในโครงการ', parent: '125',
        },
        {
          row: '615', id: '35', name: 'ผู้ประกอบการปลอมเอกสารสิทธิ์', parent: '125',
        },
        {
          row: '616', id: '37', name: 'ตรวจสอบค่าธรรมเนียม', parent: '125',
        },
        {
          row: '617', id: '41', name: 'ไม่ส่งมอบสัญญาคู่ฉบับให้', parent: '125',
        },
        {
          row: '618', id: '255', name: 'ไม่ก่อสร้าง', parent: '125',
        },
        {
          row: '619', id: '256', name: 'ไม่ดำเนินการส่งมอบพื้นที่การให้เช่า', parent: '125',
        },
        {
          row: '620', id: '257', name: 'การบริหารของนิติบุคคลไม่โปร่งใส', parent: '125',
        },
        {
          row: '621', id: '79', name: 'ยกเลิกสัญญา', parent: '128',
        },
        {
          row: '622', id: '192', name: 'มีความชำรุดหลังปลูกสร้าง', parent: '128',
        },
        {
          row: '623', id: '193', name: 'ผู้รับเหมาทิ้งงาน', parent: '128',
        },
        {
          row: '624', id: '13', name: 'มีการก่อสร้างแต่ไม่แล้วเสร็จ', parent: '128',
        },
        {
          row: '625', id: '21', name: 'มีการก่อสร้างแล้วเสร็จแต่เก็บงานไม่เรียบร้อย', parent: '128',
        },
        {
          row: '626', id: '25', name: 'ก่อสร้างไม่ถูกต้องตามแปลนที่ได้รับอนุญาต', parent: '128',
        },
        {
          row: '627', id: '158', name: 'ขอเงินคืน', parent: '129',
        },
        {
          row: '628', id: '201', name: 'ไม่ดำเนินการตามข้อตกลง', parent: '129',
        },
        {
          row: '629', id: '37', name: 'ตรวจสอบค่าธรรมเนียม', parent: '129',
        },
        {
          row: '630', id: '226', name: 'แบบสัญญาไม่เป็นไปตามที่กฎหมายกำหนด', parent: '131',
        },
        {
          row: '631', id: '253', name: 'แบบสัญญาไม่เป็นไปตามที่กฎหมายกำหนด ต้องการให้ผู้ประกอบการแก้ไขแบบสัญญาให้เป็นไปตามมาตรฐานตามที่กฎหมายกำหนด', parent: '131',
        },
        {
          row: '632', id: '96', name: 'ไม่ดำเนินการตามสัญญา', parent: '131',
        },
        {
          row: '633', id: '155', name: 'ผิดสัญญา', parent: '131',
        },
        {
          row: '634', id: '226', name: 'แบบสัญญาไม่เป็นไปตามที่กฎหมายกำหนด', parent: '132',
        },
        {
          row: '635', id: '245', name: 'ไม่คืนเงินค่ามัดจำ/ค่าจอง', parent: '132',
        },
        {
          row: '636', id: '19', name: 'ไม่จัดทำสาธารณูปโภคในโครงการ', parent: '132',
        },
        {
          row: '637', id: '16', name: 'ไม่ดำเนินการแบ่งแยกโฉนด', parent: '132',
        },
        {
          row: '638', id: '15', name: 'ไม่ดำเนินการโอนกรรมสิทธิ์', parent: '132',
        },
        {
          row: '639', id: '14', name: 'ไม่ดำเนินการตามที่โฆษณา', parent: '132',
        },
        {
          row: '640', id: '229', name: 'ไม่ดูแลและพัฒนาสาธารณูปโภคในโครงการ ', parent: '132',
        },
        {
          row: '641', id: '12', name: 'ไม่ปลูกสร้าง', parent: '132',
        },
        {
          row: '642', id: '225', name: 'ก่อสร้างไม่เหมือนบ้านตัวอย่าง', parent: '132',
        },
        {
          row: '643', id: '167', name: 'ก่อสร้างไม่แล้วเสร็จ', parent: '132',
        },
        {
          row: '644', id: '227', name: 'การบริหารงานของนิติบุคคลหมู่บ้านจัดสรรไม่โปร่งใส', parent: '132',
        },
        {
          row: '645', id: '152', name: 'ขอแก้ไขเพิ่มเติมสัญญา', parent: '132',
        },
        {
          row: '646', id: '144', name: 'ขอให้ตรวจสอบโครงการ', parent: '132',
        },
        {
          row: '647', id: '159', name: 'ขอคำปรึกษา', parent: '132',
        },
        {
          row: '648', id: '236', name: 'จำนวนเนื้อที่ไม่ตรงกับที่โฆษณา/ใบจอง/สัญญา', parent: '132',
        },
        {
          row: '649', id: '230', name: 'ปิดทางเข้าออกโครงการ', parent: '132',
        },
        {
          row: '650', id: '231', name: 'ผู้ประกอบการไม่ชำระค่าปรับล่าช้า', parent: '132',
        },
        {
          row: '651', id: '21', name: 'มีการก่อสร้างแล้วเสร็จแต่เก็บงานไม่เรียบร้อย', parent: '132',
        },
        {
          row: '652', id: '17', name: 'มีการชำรุดหลังปลูกสร้าง', parent: '132',
        },
        {
          row: '653', id: '234', name: 'สถาบันการเงินไม่อนุมัติสินเชื่อ', parent: '132',
        },
        {
          row: '654', id: '223', name: 'สถาบันการเงินอนุมัติสินเชื่อ ไม่เต็มจำนวนเงิน', parent: '132',
        },
        {
          row: '655', id: '25', name: 'ก่อสร้างไม่ถูกต้องตามแปลนที่ได้รับอนุญาต', parent: '132',
        },
        {
          row: '656', id: '268', name: 'เหตุเดือดร้อนรำคาญ', parent: '133',
        },
        {
          row: '657', id: '195', name: 'เรียกร้องค่าเสียหาย', parent: '134',
        },
        {
          row: '658', id: '127', name: 'โฆษณาเกินจริง', parent: '134',
        },
        {
          row: '659', id: '2', name: 'ได้รับบาดเจ็บจากการใช้สินค้า/บริการ', parent: '134',
        },
      ],
    },
  ],
  placeList: [
    {
      id: 4,
      label: 'สถานที่ซื้อ หรือรับบริการ',
      sublabel: '** สามารถตอบได้มากกว่า 1 รายการ',
      sublabel_color: 'danger',
      data: [
        { id: '1', name: 'ห้างสรรพสินค้า' },
        { id: '2', name: 'ร้านสะดวกชื้อ' },
        { id: '3', name: 'ที่ตั้งร้านค้า/สาขา' },
        { id: '4', name: 'โรงแรม' },
        { id: '5', name: 'ตลาดนัด' },
        { id: '6', name: 'งานแสดงสินค้า' },
        { id: '7', name: 'ศูนย์บริการ' },
        { id: '8', name: 'อินเทอร์เน็ต (online)' },
        { id: '11', name: 'อื่นๆ' },
      ],
    },
  ],
  motivateList: [
    {
      id: 5,
      label: 'มูลเหตุจูงใจที่ซื้อ หรือรับบริการ',
      sublabel: '** สามารถตอบได้มากกว่า 1 รายการ',
      sublabel_color: 'danger',
      data: [
        { id: '1', name: 'ทางสื่อสิ่งพิมพ์' },
        { id: '2', name: 'ทางโทรทัศน์' },
        { id: '3', name: 'ทางวิทยุ' },
        { id: '4', name: 'ทางอินเทอร์เน็ต' },
        { id: '5', name: 'คำชักชวนของพนักงานขาย' },
        { id: '7', name: 'อื่นๆ' },
      ],
    },
  ],
  paymentList: [
    {
      id: 6,
      label: 'วิธีการชำระเงิน',
      sublabel: '** สามารถตอบได้มากกว่า 1 รายการ',
      sublabel_color: 'danger',
      data: [
        { id: '1', name: 'เงินสด' },
        { id: '2', name: 'เงินผ่อน' },
        { id: '3', name: 'บัตรเครดิต' },
        { id: '4', name: 'เช่าซื้อ' },
        { id: '6', name: 'การชำระเงินผ่านอินเทอร์เน็ต' },
        { id: '7', name: 'อื่นๆ' },
        { id: '8', name: '​​​เช็ค (Cheque)' },
      ],
    },
  ],
}

mock.onGet('/complain-checklist/main').reply(() => [200, data.mainList])
mock.onGet('/complain-checklist/sub').reply(() => [200, data.subList])
mock.onGet('/complain-checklist/cause').reply(() => [200, data.causeList])
mock.onGet('/complain-checklist/place').reply(() => [200, data.placeList])
mock.onGet('/complain-checklist/motivate').reply(() => [200, data.motivateList])
mock.onGet('/complain-checklist/payment').reply(() => [200, data.paymentList])
